import {setCableSegmentation} from 'actions/index.js';

export const segmentCables = (engine) => {
    let {state} = engine;
    let {selectedEdge} = state.pads;
    if (!selectedEdge) {
        return;
    }
    let edgeId = selectedEdge.id;

    let edge = engine.currentSubSequence.getMessagingEdgeById(edgeId);
    if (!edge) {
        return;
    }
    if (edge.segmentation) {
        edge.segmentation = false;
    } else {
        edge.segment();
    }
    engine.dispatch(
        setCableSegmentation(
            edgeId,
            edge.segmentation));
};

const getAllCables = (subpatch) => {
    let objects = [... subpatch.zMessages, ...subpatch.zObjects];
    
    let cables = [];
    for (let o of objects) {
        for (let type in o.inlets) {
            cables = [... cables, ... o.inlets[type].connections];
        }
        if (o.effect && o.effect.inlets) {
            for (let type in o.effect.inlets) {
                cables = [... cables, ... o.effect.inlets[type].connections];
            }
        }
    }
    return cables;
};

export const segmentAllCables = (engine, subpatch) => {
    let cables = getAllCables(subpatch);
    cables.forEach(
        c => {
            c.segmentation = true;
            engine.dispatch(
                setCableSegmentation(
                    c.id,
                    true));
        });
};

